import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VMain,[_c(VContainer,{staticClass:"reset-password",attrs:{"fluid":""}},[_c(VRow,{attrs:{"align-content":"center"}},[_c('request-reset-password-mail-form'),_c('password-requested-message'),_c('fill-in-new-password')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }